
import React from "react";
import ProjectCarousel from "../components/ProjectCarousel";
import "../styles/Home.css";
import { FaGithub, FaLinkedin } from 'react-icons/fa';

export default function Home() {
    return (
        <div className="home-container">
            {/* Banner */}
            <header className="banner">

                <h1>Michael Hamilton</h1>
                <p className="tagline">Developer | Full-Stack | Game Design</p>
                <div className="social-icons">
                    <a
                    href="https://github.com/MichaelWHamilton"
                    target="_blank"
                    rel="noreferrer"
                    >
                        <FaGithub size={32} color='white' />
                    </a>

                    <a  
                    href="https://www.linkedin.com/in/michael-hamilton-81401b274/"
                    target="_blank"
                    rel="noreferrer"
                    >
                        <FaLinkedin size={32} color='white'/>
                    </a>
                </div>
                
            </header>
        
            {/* Intro */}
            <section className="intro">
            <p>
                I’m a developer with a focus on full-stack development. 
                Through academic and personal projects, I’ve built real-time chatrooms, color-based logic games, 
                database-driven applications, and even a custom game engine using C++ with SDL and Box2D.
                I'm currently pursuing full-stack development as a professional path, building a strong foundation
                across both front-end and back-end technologies.
            </p>

            </section>
        
            {/* Technologies */}
            <section className="tech-stack">
                <h2>Current Technologies I Use</h2>
                <ul className="tech-list">
                    <li>ASP.NET (C#)</li>
                    <li>Angular</li>
                    <li>TypeScript</li>
                    <li>SQL (DB2)</li>
                </ul>
                <h2>Technologies I've Work With</h2>
                <ul className="tech-list">
                    <li>C++</li>
                    <li>Java</li>
                    <li>JavaScript</li>
                    <li>React</li>
                    <li>Python</li>
                    <li>Flask & Socket.IO</li>
                    <li>SQL</li>
                    <li>MongoDb</li>
                    <li>PHP</li>
                    {/* <li>phpMyAdmin</li> */}
                    <li>MAMP</li>
                    <li>Unity (C#)</li>
                    <li>SDL / Box2D</li>
                </ul>
                <h3>Data & AI</h3>
                    <ul className="tech-list">
                        <li>Python (AI/ML)</li>
                        <li>Reinforcement Learning</li>
                        <li>Neural Networks</li>
                    </ul>
            </section>
        
            {/* Projects Placeholder */}
            <section className="projects">
                <h2>My Projects</h2>
                <ProjectCarousel/>
            </section>
        </div>
    );
}